import infoPagesLinks from '@/helpers/infoPagesLinks'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      mainMenuPresence: 'settings/mainMenuPresence',
      mainMenuTitles: 'settings/mainMenuTitles',
    }),

    mainMenuLinks() {
      // Do not show legal profile in main menu.
      const ignoredPages = ['legal_profile'];

      return infoPagesLinks.filter(page => !ignoredPages.includes(page.page_presence_setting_name) && this.mainMenuPresence[page.page_presence_setting_name])
        .map(page => ({
          ...page,
          text: this.mainMenuTitles[page.page_title_setting_name] || page.text,
        }))
    },

    footerMenuLinks() {
      return infoPagesLinks.filter(page => this.mainMenuPresence[page.page_presence_setting_name])
        .map(page => ({
          ...page,
          text: this.mainMenuTitles[page.page_title_setting_name] || page.text,
        }))
    },

    hasMainMenuLinks() {
      return ['about_us', 'delivery_and_payment', 'blog', 'offers', 'legal_profile'].some(pageName => this.mainMenuPresence[pageName])
    }
  },
}
